// Создано tools/capture/reaction.mjs — не править руками.
import type { ReactionKind } from "../../sim";

/** Сдвиг корпуса в реакции на удар от места мира вперёд по взгляду, пиксели, по кадру реакции (назад — минус). */
export const REACTION_BODY: Readonly<Record<ReactionKind, readonly number[]>> = {
  stumble: [
    2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 0, 0, -1, -2, -3, -4, -5, -5, -5, -5, -5, -5, -6, -7, -7, -8, -8, -8, -9, -9, -9,
    -9, -8, -8, -6, -5, -3, -1, 1, 2, 3, 3, 4, 4, 5, 5, 5, 4, 2, 0, -1, -2, -3, -5, -8, -11, -11, -11, -11, -11, -11,
    -11, -11,
  ],
  head: [
    2, 2, 3, 2, 2, 1, 0, -2, -4, -6, -9, -11, -13, -15, -17, -19, -21, 3, 2, 1, 1, 2, 3, 4, 4, 4, 4, 3, 1, -1, -3, -3,
    -2, -1, 1, 4, 8, 12, 16, 19, 21, 23, 23, 24, 24, 24, 24, 23, 22, 20, 18, 18, 18, 17, 14, 9, 3, 3, 3, 3, 3, 3, 3, 3,
  ],
  body: [
    3, 3, 3, 3, 3, 4, 5, 5, 6, 8, 9, 10, 11, 13, 14, 16, 18, -5, -5, -5, -5, -5, -5, -6, -7, -7, -8, -8, -8, -9, -9, -9,
    -9, -8, -8, -6, -5, -3, -1, 1, 2, 3, 3, 4, 4, 5, 5, 5, 4, 2, 0, -1, -2, -3, -5, -8, -11, -11, -11, -11, -11, -11,
    -11, -11,
  ],
  air: [
    -1, -3, -5, -9, -13, -15, -17, -18, -19, -19, -20, -19, -19, -18, -17, -16, -15, -14, -12, -10, -6, -3, 0, 2, 3, 4,
    5, 6, 6, 6, 5, 5, 4, 4, 4, 5, 6, 6, 6, 4, 3, 2, 1, 0, -1, -2, -3, -3, -4, -4, -4, -4, -4, -4, -4, -4, -4, -4, -4,
    -4, -4, -4, -4, -4,
  ],
  trip: [
    6, 5, 4, 4, 5, 7, 7, 6, 6, 6, 7, 8, 9, 12, 15, 18, 22, 26, 28, 29, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30,
    30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30,
    30, 30, 30,
  ],
};
